import axios from '@/core/http'

const fetchCategories = () => {
  return axios.get('sources/categories/').then(res => res.data)
}

export { fetchCategories }
